// Shared visual treatment for a group/subgroup name inside a proposal's item
// list — used by both the checkbox diff list (ProposalCard's GroupHeading) and
// the side-by-side preview (ProposalPreview's section headers) so group
// boundaries look the same everywhere and stay easy to scan against the item
// rows underneath them, which sit at text-sm (14px).
export const GROUP_HEADING_CLASS =
  "mb-1 border-b-2 border-brand-200 pb-1 text-base font-extrabold uppercase tracking-wide text-brand-700";
